import React from "react";
import PostsList from "./PostList";

export default function DashboardStudent() {
  return (<>
    <PostsList />
  </>)
}
